<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->

    <keep-alive>
    <router-view  v-if="$route.meta.keepneed"/>
    </keep-alive>
    <router-view  v-if="isRouterAlive?!$route.meta.keepneed:false" />

        <!-- 登录页不显示 -->
      <sevrice v-if="!$route.meta.sevrice"/>
      <!-- <sevrice  v-if="isRouterAlive" /> -->
    <footerbox class="footer"></footerbox>
    <!-- <home1></home1> -->
  </div>
</template>
<script>
import footerbox from "@/components/footer";
import sevrice from '@/components/sevrice.vue'
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  components: {
    footerbox,
    sevrice,
    // home1
  },
  methods: {

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
};
</script>
<style lang="scss">
.van-dialog__confirm {
  height: 80px !important;
}
.el-tooltip__popper.is-dark {
  color: #ffb503 !important;
}
.el-form-item__error {
  font-size: 26px !important;
}
.van-dialog {
  border-radius: 12px !important;
}
.van-dialog__footer--buttons {
  border-top: 1px solid #cccccc;
}
.van-dialog {
  padding: 10px 15px;
}
.van-dialog__cancel {
  border-right: 1px solid #cccccc !important ;
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #ffa102 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background: #ffb606 !important;
  border-color: #ffb606 !important;
}
.el-checkbox__inner:hover {
  border-color: #ffb606 !important;
}
#app {
  // width: 750px;
  margin: 0 auto;
  font-family: PingFang SC-Medium, PingFang SC !important;

}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
// 修改客服聊天界面的高度
#YSF-PANEL-MOBILE{
  #YSF-IFRAME-LAYER.ysf-chat-mobile-layeropen{
    height: 100% !important;

     }
}
</style>
